import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {HttpClient} from '@angular/common/http';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {take} from 'rxjs/operators';
import {Configuration} from '@shared/models/configuration';

@Injectable({
  providedIn: 'root',
})
export class PlatformToolDataFactoryHandler implements IPlatformToolHandler {
  magicLinkModel: MagicLinkModel;
  private selectedTabModel: TabModel;
  ngUnsubscribe = new Subject<void>();
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  invalidateSubject: InvalidateSubject;
  constructor(private httpClient: HttpClient,
              private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              protected store: Store<IQueryState>,
              private snackBarService: SnackBarService,
  ) {
    this.invalidateSubject = new InvalidateSubject();
  }
  executeCommand(command: PlatformCommand) {
    if (command.fieldValues['CommandHandler']) {
      const commandHandler = RootDynamicComponentHelper.getComponent(command.fieldValues['CommandHandler']);
      if (commandHandler) {
        commandHandler.executeCommand(command, this);
        return;
      }
    }
    this.fuseSplashScreenService.hide();
    this.executeCommandApi(command);
  }
  executeCommandApi(command: PlatformCommand) {
    console.log('Executing PlatformCommand : ', command.name);
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else if (commandResponse.fieldValues['AzureRedirectUrl']) {
            const url = commandResponse.fieldValues['AzureRedirectUrl'];
            window.open(url, '_blank');
          } else {
            this.invalidateSubject.invalidate('DataFactory');
            this.onRefresh();
          }
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.snackBarService.showInformation(error.message);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  fetchMagicLink(callback: any) {
    const id = this.magicLinkModel.id;
    const command = new PlatformCommand('CreateAzureFactoryLinkCommand', 'AdminPanelApi');
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(
      data => {
        this.magicLinkModel = data.fieldValues['PlatformLinkModel'];
        callback(data);
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Information bar error', error);
      }
    );
  }
  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }
  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  valueChanged($event) {
    console.log($event);
    switch ($event.name) {
      case 'LaunchDataFactoryCommand':
        this.executeCommandApi($event);
        break;
    }
  }

  private onRefresh() {
    this.fetchMagicLink(() => {
      const payload = {id: 'AzureDataFactoryComponent', value: this.magicLinkModel};
      this.magicLinkModelValueChanged.emit(payload);
    });
  }
}
